export const ADMIN_DASHBOARD_COPY = {
	ACTIONS: 'Actions',
	ADD_AZURE_CONFIG: 'Add Azure Config',
	ADD_CUSTOMER_FAILED: 'Failed to add customer.',
	ADD_CUSTOMER_SUCCESS: 'Customer has been added.',
	ADD_GOOGLE_CONFIG: 'Add Google Config',
	ADD_OKTA_CONFIG: 'Add Okta Config',
	ADD_ONELOGIN_CONFIG: 'Add OneLogin Config',
	AROVY_ADMIN_PANEL: 'Arovy Admin Panel',
	AROVY_SUBDOMAIN: 'Arovy Subdomain',
	AROVY_SUBDOMAIN_INVALID_FORMAT: 'Invalid subdomain format.',
	AROVY_SUBDOMAIN_REQUIRED: 'Arovy Subdomain is required.',
	AZURE_CLIENT_ID: 'Application (client) ID',
	AZURE_CLIENT_ID_INVALID_FORMAT: 'Application (client) ID must be a GUID.',
	AZURE_CLIENT_ID_REQUIRED: 'Application (client) ID is required.',
	AZURE_HELP_ARTICLE: 'Azure Zendesk Article',
	AZURE_HELP_ARTICLE_LINK:
		'https://sonarsoftware.zendesk.com/hc/en-us/articles/4420332240909-How-to-Set-Up-Microsoft-Azure-SSO',
	AZURE_TENANT_ID: 'Directory (tenant) ID',
	AZURE_TENANT_ID_INVALID_FORMAT: 'Directory (tenant) ID must be a GUID.',
	AZURE_TENANT_ID_REQUIRED: 'Directory (tenant) ID is required.',
	CLEAR: 'Clear',
	CLICK_TO_UPLOAD: 'Click to Upload',
	CONFIGURATION: 'Configuration',
	CONFIGURE_IMPORTS: 'Configure Imports',
	CONFIGURE_IMPORTS_FOR: (name: string): string => `Configure Imports for ${name}`,
	COPY_PASSWORD_RESET_LINK: 'Copy Password Reset Link',
	COPY_USER_INVITE_LINK: 'Copy User Invite Link',
	CUSTOMER_NAME_REQUIRED: 'Customer name is required.',
	CUSTOMER_SETTINGS: 'Customer Settings',
	DELETE_OIDC_CONFIG_CONFIRMATION: 'Are you sure you want to delete this OIDC configuration?',
	DELETE_OIDC_CONFIG_ERRORED: 'An error occurred while deleting the OIDC configuration.',
	DELETE_OIDC_CONFIG_FAILED: 'Failed to delete the OIDC configuration.',
	EMAIL: 'Email',
	ENABLED: 'Enabled',
	ENROLLED_ON: (date: string): string => `Customer since ${date}`,
	FAILED: 'Failed',
	FEATURE_FLAGS: 'Feature Flags',
	FIRST_NAME: 'First Name',
	FORCE_FULL_REFRESH: 'Force Full Refresh',
	FREQUENCY: 'Frequency',
	FREQUENCY_DAILY: 'Daily',
	FREQUENCY_WEEKLY: 'Weekly',
	GOOGLE_CLIENT_ID: 'Client ID',
	GOOGLE_CLIENT_ID_REQUIRED: 'Client ID is required.',
	GOOGLE_HELP_ARTICLE: 'Google Zendesk Article',
	GOOGLE_HELP_ARTICLE_LINK: '',
	ID: 'ID',
	IMPERSONATE: 'Impersonate',
	IMPORT_CONFIG: 'Import Config',
	INSTANCE_URL: 'Instance URL',
	INVALID_SALESFORCE_ACCOUNT_ID: 'Invalid Salesforce account ID.',
	ISSUED_BY_AZURE: 'Issued by Azure',
	ISSUED_BY_GOOGLE: 'Issued by Google',
	ISSUED_BY_OKTA: 'Issued by Okta',
	ISSUED_BY_ONELOGIN: 'Issued by OneLogin',
	ISSUER: 'Issuer',
	IS_SANDBOX: 'Sandbox?',
	LAST_NAME: 'Last Name',
	LAST_SYNC: 'Last Sync',
	LOCK: 'Lock',
	LOCKED: 'Locked',
	LOCK_ALL_USERS: 'Lock All Users',
	LOCK_ALL_USERS_FAILED: 'Failed to lock all users.',
	LOCK_CUSTOMER: 'Lock Customer',
	LOG_OUT: 'Log Out',
	METRIC_TOOLTIP_GLOBAL_KEY: 'The customer\'s global key that uniquely identifies it across all shards.',
	METRIC_TOOLTIP_LOCAL_KEY: 'The customer\'s local key that uniquely identifies it within its own shard.',
	METRIC_TOOLTIP_SHARD: 'The name of the database shard that contains the customer\'s data.',
	NEW_CUSTOMER_NAME: 'New Customer Name',
	NO: 'No',
	OIDC_CONFIGURATON: 'OIDC Configuration',
	OKTA_CLIENT_ID: 'Client ID',
	OKTA_CLIENT_ID_REQUIRED: 'Client ID is required.',
	OKTA_DOMAIN: 'Okta Domain',
	OKTA_DOMAIN_INVALID_FORMAT: 'Format must match: https://customer.okta.com',
	OKTA_DOMAIN_REQUIRED: 'Okta Domain is required.',
	OKTA_HELP_ARTICLE: 'Okta Zendesk Article',
	OKTA_HELP_ARTICLE_LINK: 'https://sonarsoftware.zendesk.com/hc/en-us/articles/360050634371-How-to-Set-Up-OKTA-SSO',
	ONELOGIN_CLIENT_ID: 'Client ID',
	ONELOGIN_CLIENT_ID_REQUIRED: 'Client ID is required.',
	ONELOGIN_HELP_ARTICLE: 'OneLogin Zendesk Article',
	ONELOGIN_HELP_ARTICLE_LINK: 'https://sonarsoftware.zendesk.com/hc/en-us/articles/14181871811469',
	ONELOGIN_ISSUER_URL: 'Issuer URL',
	ONELOGIN_ISSUER_URL_INVALID_FORMAT: 'Format must match: https://customer.onelogin.com/oidc/2',
	ONELOGIN_ISSUER_URL_REQUIRED: 'Issuer URL is required.',
	ORGANZATION_NAME: 'Organization Name',
	PASSWORD: 'Password',
	PATCH_TASK_CONFIG_ERRORED: 'An error occurred while updating the task configuration.',
	PATCH_TASK_CONFIG_FAILED: 'Failed to update task configuration.',
	PATCH_TASK_CONFIG_REQUESTED: 'Updated task configuration.',
	PRODUCTION: 'Production',
	REINDEX_CUSTOMER_FAILED: 'Failed to reindex customer.',
	REINDEX_CUSTOMER_REQUESTED: 'Customer reindex in progress.',
	REINDEX_IN_SHARD_CATALOG: 'Reindex in Shard Catalog',
	REMOVE_CUSTOMER_FAILED: 'Failed to remove customer.',
	REMOVE_CUSTOMER_SUCCESS: 'Customer has been removed.',
	RENAME_CUSTOMER: 'Rename Customer',
	RESEND_USER_INVITE: 'Resend User Invite',
	RESEND_USER_INVITE_FAILED: 'User invite email could not be sent.',
	RESEND_USER_INVITE_SUCCESS: 'User invite email has been sent.',
	RETURN_TO_DASHBOARD: 'Return to Dashboard',
	SALESFORCE_ACCOUNT_ID: 'Salesforce Account ID',
	SALESFORCE_PACKAGE_TAGS: 'Salesforce Package Tags',
	SALESFORCE_SETUP: 'Salesforce Setup',
	SALESFORCE_USERNAME: 'Salesforce Username',
	SANDBOX: 'Sandbox',
	SEARCH_CUSTOMERS_PLACEHOLDER: 'Search by Customer Name',
	SEARCH_FEATURE_FLAGS_PLACEHOLDER: 'Search by Name',
	SEARCH_PLACEHOLDER: 'Search Customers, Organizations, and Users',
	SEARCH_USERS_PLACEHOLDER: 'Search by Email',
	SEND_PASSWORD_RESET: 'Send Password Reset',
	SEND_PASSWORD_RESET_FAILED: 'Password reset email could not be sent.',
	SEND_PASSWORD_RESET_SUCCESS: 'Password reset email has been sent.',
	SHARD_NAME_NONE: '(none)',
	SSO_ISSUER: 'SSO Issuer',
	START_NEW_SYNC: 'Start New Sync',
	START_NEW_SYNC_CONFIRMATION: 'Are you sure you want to start a new sync for this organization?',
	SUBMIT: 'Submit',
	SYNCING: 'Syncing',
	SYNC_IN_PROGRESS: 'Sync in Progress',
	SYNC_SECURITY_ALERTS: 'Sync Security Alerts',
	TIMELINE_RETENTION_PERIOD: 'Timeline Retention Period (Days)',
	UNKNOWN_ISSUER: 'Unknown Issuer',
	UNLOCK: 'Unlock',
	UNLOCK_CUSTOMER: 'Unlock Customer',
	UPDATE_CUSTOMER_FAILED: 'Failed to update customer.',
	UPDATE_FEATURE_FLAG_FAILED: 'Failed to update feature flag.',
	UPDATE_FEATURE_FLAG_SUCCESS: 'Feature flag has been updated.',
	UPDATE_OIDC_CONFIGURATION_ERRORED: 'An error occurred while updating the OIDC configuration.',
	UPDATE_OIDC_CONFIGURATION_FAILED: 'Failed to update the OIDC configuration.',
	UPDATE_USER_FAILED: 'Failed to update user.',
	USERS: 'Users',
	USER_UTILIZES_SSO: 'User only utilizes SSO and does not have a password login',
	YES: 'Yes'
};
